import {style} from "typestyle";

export const Icon = style({
    display: "block",
    width: "22px",
    height: "22px",
    marginRight: "6px"
});